/**
 * Position of referenced corporate entity or person.
 *
 * Refer to Position code table by entity type provided
 * {@link https://public.cloud.myinfo.gov.sg/myinfobiz/myinfo-biz-specs-v2.0.html#section/Support HERE}
 * in the Support section for list of possible values.
 */
export enum PositionCode {
  Administrator = '1',
  Agent = '2',
  AgentOfForeignFirm = '3',
  Auditor = '4',
  AuthorisedRepresentative = '5',
  ChiefExecutiveOfficer = '6',
  Director = '7',
  DirectorUnderSection17_3_dOfTheAccountantsAct = '8',
  EstateOff = '9',
  ExecutorExecutrix = '10',
  GeneralPartner = '11',
  GeneralPartnerAsAgentOfForeignFirm = '12',
  GeneralPartnerAsNomineeTrustee = '13',
  LimitedPartner = '14',
  Manager = '15',
  ManagingDirector = '16',
  Member = '17',
  NextOfKin = '18',
  Nominee = '19',
  NomineeTrustee = '20',
  Officer = '21',
  Owner = '22',
  Partner = '23',
  PartnerUnderSection18_3_cOfTheAccountantsAct = '24',
  PartnerUnderSection18A_3_eOfTheAccountantsAct = '25',
  PublicAccountantEmployee = '26',
  PublicAccountingEmployeeForALLPOnly = '27',
  Secretary = '28',
  SoleProprietorPartner = '29',
  Trustee = '30',
}
